import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';

@Component({
	selector: 'app-value-input-dialog',
	templateUrl: 'value.dialog.html',
	styleUrls: ['./value.dialog.css']
})
// tslint:disable-next-line: component-class-suffix
export class ValueInputDialog implements OnInit {

	variable: any;

	@ViewChild('varForm', {static: false}) varForm: NgForm;

	constructor(
		private dialog: MatDialog,
		private translateService: TranslateService,
		private dialogRef: MatDialogRef<ValueInputDialog>,
		@Inject(MAT_DIALOG_DATA) _data: any
	) {
		this.variable = _data;
	}

	ngOnInit() {
	}

	onOk(): void {
		if (!this.varForm.valid) {
			if (this.varForm.controls) {
				for (const control in this.varForm.controls) {
					this.varForm.controls[control].markAsTouched();
				}
			}	
		} else {
			this.dialogRef.close({
				result: true,
				variable: this.variable
			});	
		}
	}

	onClose(): void {
		this.dialogRef.close({
			result: false
		});
	}

}

